function block(type, data) {
  return Object.assign({ type: type }, data || {})
}

function section(id, title, blocks) {
  return { id: id, title: title, blocks: blocks || [] }
}

function p(text) {
  return block('paragraph', { text: text })
}

function bullets(items) {
  return block('bullets', { items: items })
}

function table(columns, rows, variant) {
  return block('table', { columns: columns, rows: rows, variant: variant || 'overview' })
}

function figure(imageKey, alt, caption) {
  return block('figure', { imageKey: imageKey, alt: alt || '', caption: caption || '' })
}

function gallery(imageKeys, caption, cols, fit, ratio) {
  var items = (imageKeys || []).map(function (key) {
    return { imageKey: key }
  })
  return block('gallery', {
    items: items,
    caption: caption || '',
    cols: cols || items.length || 2,
    fit: fit || 'cover',
    ratio: ratio || 'square'
  })
}

function tip(title, text) {
  return block('tip', { title: title, text: text })
}

function promptExample(label, prompt) {
  return block('prompt-example', { label: label, prompt: prompt })
}

function faqItem(question, answer) {
  return block('faq-item', { question: question, answer: answer })
}

function scenarioItem(title, text) {
  return block('scenario-item', { title: title, text: text })
}

function stepsBlock() {
  return block('steps')
}

function prosConsBlock() {
  return block('pros-cons')
}

function cta(title, text, buttonLabel, buttonPath) {
  return block('cta', {
    title: title,
    text: text,
    buttonLabel: buttonLabel,
    buttonPath: buttonPath
  })
}

function links(title, items) {
  return block('links', { title: title, items: items || [] })
}

var articleBodies = require('./articleBodies.js')
var promptCatalog = require('./promptCatalog.js')

// 文章 overview / FAQ 正文：hub/{locale}.js 内 ARTICLE_BODIES（zh 在 zh.js 手写全文）

function getArticleBody(article, locale) {
  if (locale === 'zh' || !article || !article.slug) return null
  return articleBodies.getArticleBody(locale, article.slug)
}

function resolveArticlePack(pack, localeBody, isTool) {
  if (!localeBody) return pack
  var next = Object.assign({}, pack)
  if (localeBody.overview) next.overview = localeBody.overview
  if (isTool && localeBody.toolFaq) next.toolFaq = localeBody.toolFaq
  if (isTool && localeBody.workflow) {
    next.table = Object.assign({}, pack.table, { toolWorkflow: localeBody.workflow })
  }
  if (!isTool && localeBody.modelFaq) next.modelFaq = localeBody.modelFaq
  return next
}

var RELATED_LINK_TITLES = {
  en: 'Related models and tools',
  ja: '関連モデルとツール',
  ko: '관련 모델 및 도구',
  fr: 'Modèles et outils associés',
  es: 'Modelos y herramientas relacionados',
  it: 'Modelli e strumenti correlati',
  de: 'Verwandte Modelle und Tools',
  pt: 'Modelos e ferramentas relacionados',
  pl: 'Powiązane modele i narzędzia',
  ar: 'النماذج والأدوات ذات الصلة'
}

var TOOL_SCENARIO_COPY = {
  en: {
    title: 'Common processing scenarios',
    intro: 'Start with the scenario closest to your image, then adjust the selection and workflow to match the source file.'
  },
  ja: {
    title: 'よくある処理シーン',
    intro: '画像に最も近いケースを選び、元ファイルに合わせて選択範囲と作業手順を調整してください。'
  },
  ko: {
    title: '자주 사용하는 처리 상황',
    intro: '이미지와 가장 가까운 상황을 먼저 고른 뒤 원본 파일에 맞게 선택 영역과 작업 순서를 조정하세요.'
  },
  fr: {
    title: 'Scénarios de traitement courants',
    intro: 'Commencez par le scénario le plus proche de votre image, puis adaptez la sélection et le workflow au fichier source.'
  },
  es: {
    title: 'Escenarios de procesamiento habituales',
    intro: 'Empieza por el escenario más parecido a tu imagen y ajusta la selección y el flujo de trabajo al archivo original.'
  },
  it: {
    title: 'Scenari di elaborazione comuni',
    intro: 'Parti dallo scenario più vicino alla tua immagine, poi adatta la selezione e il workflow al file originale.'
  },
  de: {
    title: 'Häufige Bearbeitungsszenarien',
    intro: 'Beginne mit dem Szenario, das deinem Bild am nächsten kommt, und passe Auswahl und Ablauf an die Quelldatei an.'
  },
  pt: {
    title: 'Cenários comuns de processamento',
    intro: 'Comece pelo cenário mais próximo da sua imagem e ajuste a seleção e o fluxo ao arquivo original.'
  },
  pl: {
    title: 'Typowe scenariusze przetwarzania',
    intro: 'Zacznij od scenariusza najbardziej zbliżonego do obrazu, a następnie dopasuj zaznaczenie i workflow do pliku źródłowego.'
  },
  ar: {
    title: 'سيناريوهات المعالجة الشائعة',
    intro: 'ابدأ بالسيناريو الأقرب إلى صورتك، ثم عدّل التحديد وسير العمل بما يناسب الملف الأصلي.'
  }
}

var MODEL_SCENARIO_COPY = {
  en: {
    title: 'Real-world creative scenarios',
    intro: 'Choose the scenario closest to your deliverable, then replace the subject, style, aspect ratio, and platform with your own requirements.'
  },
  ja: {
    title: '実際のクリエイティブシーン',
    intro: '目的に最も近いケースを選び、主体、スタイル、比率、掲載先を自分の要件に置き換えてください。'
  },
  ko: {
    title: '실제 크리에이티브 활용 상황',
    intro: '결과물과 가장 가까운 상황을 고른 뒤 주제, 스타일, 화면 비율, 게시 플랫폼을 요구 사항에 맞게 바꾸세요.'
  },
  fr: {
    title: 'Scénarios créatifs concrets',
    intro: 'Choisissez le scénario le plus proche du livrable, puis remplacez le sujet, le style, le format et la plateforme selon vos besoins.'
  },
  es: {
    title: 'Escenarios creativos reales',
    intro: 'Elige el escenario más parecido al resultado que necesitas y adapta el tema, el estilo, la proporción y la plataforma.'
  },
  it: {
    title: 'Scenari creativi reali',
    intro: 'Scegli lo scenario più vicino al risultato finale e adatta soggetto, stile, proporzioni e piattaforma alle tue esigenze.'
  },
  de: {
    title: 'Praktische Kreativszenarien',
    intro: 'Wähle das Szenario, das deinem Ergebnis am nächsten kommt, und passe Motiv, Stil, Seitenverhältnis und Plattform an.'
  },
  pt: {
    title: 'Cenários criativos reais',
    intro: 'Escolha o cenário mais próximo do resultado desejado e adapte o tema, o estilo, a proporção e a plataforma.'
  },
  pl: {
    title: 'Praktyczne scenariusze kreatywne',
    intro: 'Wybierz scenariusz najbliższy oczekiwanemu materiałowi, a następnie dopasuj temat, styl, proporcje i platformę.'
  },
  ar: {
    title: 'سيناريوهات إبداعية واقعية',
    intro: 'اختر السيناريو الأقرب إلى النتيجة المطلوبة، ثم عدّل الموضوع والأسلوب ونسبة الأبعاد والمنصة وفق احتياجاتك.'
  }
}

var RELATED_COMPARISON_COPY = {
  en: {
    model: 'Run the same brief through {links}, then choose by composition speed, final-detail quality, illustration style, and text control.',
    tool: 'Use {links} as connected steps when the source also needs correction, cleanup, or a new generated visual.'
  },
  ja: {
    model: '同じ要件を {links} で試し、構図の速さ、最終ディテール、イラスト表現、文字制御で使い分けます。',
    tool: '元画像の補正、クリーンアップ、新しいビジュアル生成が必要な場合は、{links} を一連の工程として使い分けます。'
  },
  ko: {
    model: '같은 요구사항을 {links}에서 테스트한 뒤 구도 속도, 최종 디테일, 일러스트 스타일, 텍스트 제어에 따라 선택하세요.',
    tool: '원본 보정, 정리 또는 새 이미지 생성이 함께 필요하면 {links}를 연결된 작업 단계로 사용하세요.'
  },
  fr: {
    model: 'Testez le même brief avec {links}, puis choisissez selon la vitesse de composition, le niveau de détail final, le style illustratif et le contrôle du texte.',
    tool: 'Utilisez {links} comme étapes complémentaires lorsque la source demande aussi une correction, un nettoyage ou un nouveau visuel généré.'
  },
  es: {
    model: 'Prueba el mismo encargo con {links} y elige según la rapidez de composición, el detalle final, el estilo de ilustración y el control del texto.',
    tool: 'Usa {links} como pasos conectados cuando la imagen también necesite corrección, limpieza o un nuevo visual generado.'
  },
  it: {
    model: 'Prova lo stesso brief con {links}, poi scegli in base a velocità di composizione, dettaglio finale, stile illustrativo e controllo del testo.',
    tool: 'Usa {links} come passaggi collegati quando la sorgente richiede anche correzione, pulizia o un nuovo visual generato.'
  },
  de: {
    model: 'Teste dasselbe Briefing mit {links} und wähle dann nach Kompositionsgeschwindigkeit, finaler Detailqualität, Illustrationsstil und Textkontrolle.',
    tool: 'Nutze {links} als zusammenhängende Schritte, wenn das Ausgangsbild zusätzlich korrigiert, bereinigt oder neu gestaltet werden soll.'
  },
  pt: {
    model: 'Teste o mesmo briefing com {links} e escolha pela velocidade de composição, qualidade dos detalhes finais, estilo de ilustração e controle de texto.',
    tool: 'Use {links} como etapas conectadas quando a imagem também precisar de correção, limpeza ou de um novo visual gerado.'
  },
  pl: {
    model: 'Przetestuj ten sam brief w {links}, a potem wybierz według szybkości kompozycji, jakości detali, stylu ilustracji i kontroli tekstu.',
    tool: 'Użyj {links} jako połączonych etapów, gdy materiał wymaga także korekcji, czyszczenia lub wygenerowania nowej grafiki.'
  },
  ar: {
    model: 'جرّب الوصف نفسه باستخدام {links}، ثم اختر وفق سرعة التكوين وجودة التفاصيل النهائية وأسلوب الرسم والتحكم في النص.',
    tool: 'استخدم {links} كخطوات مترابطة عندما تحتاج الصورة أيضًا إلى تصحيح أو تنظيف أو إنشاء مرئي جديد.'
  }
}

var RELATED_LINK_LABELS = {
  '/image-models/flux-1-ai-image-generator': 'Flux Schnell',
  '/image-models/flux-2-ai-image-generator': 'FLUX.2',
  '/image-models/seedream-ai-image-generator': 'Seedream 5',
  '/image-models/qwen-image-2-0-pro-ai-image-generator': 'Qwen Image 2.0 Pro',
  '/image-models/stable-diffusion-ai-image-generator': 'Stable Diffusion 3.5',
  '/image-models/z-image-turbo-ai-image-generator': 'Z Image Turbo',
  '/image-models/midjourney-ai-image-generator': 'Midjourney',
  '/image-models/gpt-image-ai-image-generator': 'GPT Image 1.5',
  '/tools/watermark-remover': 'AI Watermark Remover',
  '/tools/handwritten-erase': 'Handwriting Eraser',
  '/tools/doc-crop-enhance': 'Image Crop & Dewarp',
  '/hub/articles/seedream-ai-image-generator-review': 'Seedream 5',
  '/hub/articles/flux-ai-image-generator-review': 'FLUX.2',
  '/hub/articles/midjourney-alternative-online': 'Midjourney',
  '/hub/articles/gpt-image-generator-guide': 'GPT Image 1.5',
  '/hub/articles/qwen-image-generator-review': 'Qwen Image 2.0 Pro',
  '/hub/articles/z-image-ai-generator-review': 'Z Image Turbo',
  '/hub/articles/stable-diffusion-online-generator': 'Stable Diffusion 3.5',
  '/hub/articles/ai-watermark-remover-online': 'AI Watermark Remover',
  '/hub/articles/handwriting-eraser-online': 'Handwriting Eraser',
  '/hub/articles/image-crop-dewarp-online': 'Image Crop & Dewarp'
}

function normalizeRelatedLinkPath(path) {
  return String(path || '').replace(/^\/zh(?=\/hub\/)/, '')
}

function normalizeRelatedLink(item) {
  var path = normalizeRelatedLinkPath(item && item.path)
  if (!path) return null
  return {
    label: RELATED_LINK_LABELS[path] || item.label || path,
    path: path
  }
}

function collectArticleMedia(article) {
  var media = {
    gallery: null,
    figure: null,
    promptImages: [],
    relatedLinks: []
  }
  var relatedPaths = {}
  function addRelatedLink(linkItem) {
    var normalized = normalizeRelatedLink(linkItem)
    if (!normalized || relatedPaths[normalized.path]) return
    relatedPaths[normalized.path] = true
    media.relatedLinks.push(normalized)
  }
  var sections = article && article.sections ? article.sections : []
  var i
  var j
  for (i = 0; i < sections.length; i++) {
    var blocks = sections[i].blocks || []
    for (j = 0; j < blocks.length; j++) {
      var item = blocks[j]
      if (!media.gallery && item.type === 'gallery' && item.items && item.items.length) {
        media.gallery = {
          imageKeys: item.items.map(function (entry) { return entry.imageKey }).filter(Boolean),
          cols: item.cols,
          fit: item.fit,
          ratio: item.ratio
        }
      }
      if (!media.figure && item.type === 'figure' && item.imageKey) {
        media.figure = item.imageKey
      }
      if (item.type === 'prompt-example' && item.imageKey) {
        media.promptImages.push(item.imageKey)
      }
      if (item.type === 'links' && item.items && item.items.length) {
        item.items.forEach(function (linkItem) {
          addRelatedLink(linkItem)
        })
      }
    }
  }
  return media
}

function fmt(template, data) {
  return String(template || '').replace(/\{([a-zA-Z0-9_]+)\}/g, function (_, key) {
    return data[key] == null ? '' : data[key]
  })
}

function fillList(list, data) {
  return (list || []).map(function (item) {
    if (typeof item === 'string') return fmt(item, data)
    return {
      title: fmt(item.title, data),
      text: fmt(item.text, data)
    }
  })
}

var BASE = {
  sections: {
    tldr: 'Quick Take',
    overview: 'What this guide covers',
    workflow: 'Recommended workflow',
    prompts: 'Prompt examples',
    tips: 'Practical tips',
    prosCons: 'Pros and cons',
    compare: 'Which model fits',
    nextSteps: 'What to do next',
    faq: 'FAQ',
    conclusion: 'Conclusion and next step'
  },
  table: {
    columns: ['Item', 'Guidance'],
    bestFor: 'Best for',
    watch: 'Watch for',
    workflow: 'Workflow',
    next: 'Next step',
    modelBest: 'AI image generation, commercial visual drafts, product scenes, social covers, and prompt testing.',
    toolBest: 'Cleaning existing images, document photos, scanned pages, product assets, and reusable source material.',
    modelWatch: 'Check text, brand details, product accuracy, and edge cases before using the result commercially.',
    toolWatch: 'Use a clean source image when possible and inspect edges, shadows, and small text before exporting.',
    modelWorkflow: 'Start broad, generate several versions, then refine the prompt and switch models if the visual style is wrong.',
    toolWorkflow: 'Upload a test image, mark the problem area, review the output, then process the final file.'
  },
  overview: [
    '{title} is useful when you need a browser-based workflow instead of setting up local tools. This article focuses on where it fits, how to start, and what to check before using the output.',
    '{excerpt}',
    'Use the guide as a practical checklist: confirm the use case, prepare the input or prompt, generate a few options, then open {target} for the final test.'
  ],
  modelSteps: [
    { title: 'Define the use case', text: 'Write whether the image is for ecommerce, ads, social media, a poster, a concept draft, or a production asset.' },
    { title: 'Describe the subject clearly', text: 'Include the product, scene, lighting, style, camera angle, composition, and aspect ratio.' },
    { title: 'Generate several directions', text: 'Create a few versions first, then refine color, material, background, or layout based on the strongest result.' },
    { title: 'Verify before delivery', text: 'Check text, logos, product details, hands, reflections, and platform requirements before publishing.' }
  ],
  toolSteps: [
    { title: 'Upload a test image', text: 'Start with one representative image so you can inspect quality before processing important files.' },
    { title: 'Mark the problem area', text: 'Select the watermark, handwriting, edge, shadow, or distortion as tightly as possible.' },
    { title: 'Review the output', text: 'Zoom in on edges, text, repeated textures, and background repairs before accepting the result.' },
    { title: 'Continue the workflow', text: 'Use the cleaned image in a generator, product listing, OCR archive, or design document.' }
  ],
  modelPros: [
    'Runs in the browser and is quick to test.',
    'Good for comparing multiple visual directions before committing.',
    'Works well with clear prompts and commercial use cases.',
    'Easy to pair with other Miral models when the first result needs a different style.'
  ],
  modelCons: [
    'Generated text and fine brand details still need manual review.',
    'Some materials, faces, and reflections may require another model or extra attempts.',
    'Prompt quality strongly affects the final result.',
    'Final commercial use should still follow brand and platform rules.'
  ],
  toolPros: [
    'Useful for fixing existing assets without a heavy editing workflow.',
    'Fast enough to test several source images.',
    'Works well before OCR, product listings, or further AI generation.',
    'Keeps the process inside the browser.'
  ],
  toolCons: [
    'Very low-resolution files limit the repair quality.',
    'Complex backgrounds may need a second pass.',
    'Important documents still need careful manual review.',
    'Results should be checked before legal, academic, or commercial use.'
  ],
  modelPrompts: [
    { title: 'Product visual', text: 'A clean commercial product image for {title}, soft studio light, realistic materials, clear subject, ecommerce-ready composition.' },
    { title: 'Social cover', text: 'A social media cover inspired by {title}, modern layout, strong focal point, balanced empty space, high-quality visual style.' },
    { title: 'Ad concept', text: 'A polished advertising concept for {title}, product-forward composition, realistic lighting, premium brand mood, no unreadable text.' }
  ],
  toolTips: [
    { title: 'Work on a copy', text: 'Keep the original file and test the repair on a duplicate first.' },
    { title: 'Inspect small details', text: 'Zoom in around text, borders, shadows, and repeated backgrounds after processing.' },
    { title: 'Use the right next tool', text: 'After cleanup, send the result to a generator, watermark remover, handwriting eraser, or document correction workflow as needed.' }
  ],
  modelFaq: [
    { q: 'Do I need a complex prompt?', a: 'No. Start with subject, scene, lighting, style, and aspect ratio. Add details only after the first result shows the direction.' },
    { q: 'Can I use the result for ecommerce or marketing?', a: 'Yes, but check product accuracy, brand details, text, and platform requirements before publishing.' },
    { q: 'What if the first result is not right?', a: 'Generate several versions, change the prompt, or switch to another Miral model that fits the style better.' },
    { q: 'Is it better than every other model?', a: 'No single model wins every task. Choose based on realism, text control, illustration style, and the final use case.' }
  ],
  toolFaq: [
    { q: 'What image should I upload first?', a: 'Use a clear sample that represents the real problem: watermark, handwriting, skew, shadows, or document distortion.' },
    { q: 'Will the result always be perfect?', a: 'No. Low resolution, heavy marks, and complex backgrounds can still need another pass or manual review.' },
    { q: 'Can I use it before OCR or printing?', a: 'Yes. Review readability first, especially around small text, tables, borders, and signatures.' },
    { q: 'Can I combine it with other Miral tools?', a: 'Yes. Cleanup often works best before image generation, OCR, document correction, or product listing work.' }
  ],
  conclusion: {
    paragraph: '{title} is best treated as a practical workflow step, not a magic button. Use it to move quickly, then review the result with the real destination in mind.',
    bullets: [
      'Start with one clear use case.',
      'Generate or process a small test first.',
      'Check quality before publishing or exporting.',
      'Open {target} when you are ready to try the workflow.'
    ],
    ctaTitle: 'Try it in Miral',
    ctaText: 'Use the article as a checklist and run a first test in the matching Miral feature.'
  },
  profile: {
    headerHint: 'Includes practical takeaways, examples, pros and cons, and a clear next step.',
    tldrLabel: 'Summary',
    tldrDesc: 'Check the fit first, then follow the workflow below.',
    faqLabel: 'FAQ',
    intentsLabel: 'Guide',
    conclusionLabel: 'Next',
    sideCtaKicker: 'Recommended entry',
    sideCtaDesc: 'Use the checklist in this article and run a quick test in Miral.',
    navLabel: 'In this article'
  },
  searchTerms: ['AI image generator', 'AI image tool', 'prompt guide', 'online workflow', 'Miral'],
  layoutProfiles: {
    review: {
      headerHint: 'Includes practical takeaways, prompt examples, pros and cons, and model selection notes.',
      tldrLabel: 'Verdict',
      tldrTitle: 'Review summary',
      tldrDesc: 'Check the best-fit use cases first, then compare the workflow below.',
      faqLabel: 'FAQ',
      faqTitle: 'Common questions',
      intentsLabel: 'Guide',
      conclusionLabel: 'Summary',
      conclusionTitle: 'Conclusion and next step',
      sideCtaKicker: 'Recommended entry',
      sideCtaDesc: 'Take the prompts and checklist into Miral for a quick test.',
      navLabel: 'In this article'
    },
    alternatives: {
      headerHint: 'Compares browser-based alternatives and helps you pick by actual use case.',
      tldrLabel: 'Compare',
      tldrTitle: 'Selection summary',
      tldrDesc: 'Decide whether you need art exploration, commercial output, text control, or local-style generation.',
      faqLabel: 'Q&A',
      faqTitle: 'Selection questions',
      intentsLabel: 'Pick',
      conclusionLabel: 'Next',
      conclusionTitle: 'Conclusion and next step',
      sideCtaKicker: 'Try this first',
      sideCtaDesc: 'Switch models in one place and compare results quickly.',
      navLabel: 'Comparison sections'
    },
    'prompt-guide': {
      headerHint: 'Focused on prompt structure for posters, product visuals, readable text, and social covers.',
      tldrLabel: 'Prompt',
      tldrTitle: 'Prompt essentials',
      tldrDesc: 'Copy a pattern, adjust the subject and platform, then generate several versions.',
      faqLabel: 'FAQ',
      faqTitle: 'Common questions',
      intentsLabel: 'Prompt',
      conclusionLabel: 'Try',
      conclusionTitle: 'Conclusion and next step',
      sideCtaKicker: 'Try the prompt',
      sideCtaDesc: 'Copy a prompt example into Miral and refine from the best output.',
      navLabel: 'In this article'
    },
    'how-to': {
      headerHint: 'Step-by-step workflow for cleaning or correcting an existing image.',
      tldrLabel: 'Quick',
      tldrTitle: 'Quick summary',
      tldrDesc: 'Confirm the source image type first, then process a small test file.',
      faqLabel: 'Help',
      faqTitle: 'Common questions',
      intentsLabel: 'Tips',
      conclusionLabel: 'Done',
      conclusionTitle: 'Conclusion and next step',
      sideCtaKicker: 'Open the tool',
      sideCtaDesc: 'Upload one small image first, review the result, then process the final asset.',
      navLabel: 'Workflow sections'
    }
  }
}

var ARTICLE_ALIGNMENT_TARGETS = {
  'seedream-ai-image-generator-review': { prompts: 8, steps: 4, pros: 4, cons: 4, intents: 16 },
  'flux-ai-image-generator-review': { prompts: 8, steps: 4, pros: 4, cons: 4, intents: 15 },
  'midjourney-alternative-online': { prompts: 7, steps: 4, pros: 4, cons: 4, intents: 12 },
  'gpt-image-generator-guide': { prompts: 7, steps: 4, pros: 4, cons: 4, intents: 15 },
  'qwen-image-generator-review': { prompts: 7, steps: 4, pros: 4, cons: 4, intents: 15 },
  'z-image-ai-generator-review': { prompts: 6, steps: 4, pros: 4, cons: 4, intents: 15 },
  'stable-diffusion-online-generator': { prompts: 7, steps: 4, pros: 4, cons: 4, intents: 12 },
  'ai-watermark-remover-online': { prompts: 6, steps: 4, pros: 4, cons: 4, intents: 15 },
  'ai-background-remover-online': { prompts: 6, steps: 4, pros: 4, cons: 4, intents: 12 },
  'ecommerce-product-background-removal': { prompts: 6, steps: 5, pros: 4, cons: 4, intents: 12 },
  'ai-portrait-background-remover': { prompts: 6, steps: 4, pros: 4, cons: 4, intents: 12 },
  'ai-background-changer-online': { prompts: 6, steps: 5, pros: 4, cons: 4, intents: 12 },
  'handwriting-eraser-online': { prompts: 6, steps: 5, pros: 5, cons: 4, intents: 18 },
  'image-crop-dewarp-online': { prompts: 6, steps: 4, pros: 5, cons: 4, intents: 17 }
}

function getAlignmentTarget(article, isTool) {
  return ARTICLE_ALIGNMENT_TARGETS[article.slug] || {
    prompts: isTool ? 6 : 8,
    steps: 4,
    pros: 4,
    cons: 4
  }
}

var COMMON_LOCALE_CONTENT = {
  ja: {
    profile: { headerHint: '実用ポイント、例、長所と短所、次の操作をまとめています。', tldrLabel: '要約', tldrDesc: 'まず適用場面を確認し、下の流れに沿って試します。', faqLabel: 'FAQ', intentsLabel: 'ガイド', conclusionLabel: '次へ', sideCtaKicker: 'おすすめ入口', sideCtaDesc: 'この記事のチェックリストを使い、Miralで試してください。', navLabel: 'この記事の内容' },
    modelPros: ['ブラウザで試せて初期設定が軽い。', '複数の方向性を素早く比較できる。', '用途を明確に書くと安定しやすい。', '必要なら別のMiralモデルに切り替えやすい。'],
    modelCons: ['文字やブランド細部は確認が必要。', '素材感や反射は追加生成が必要な場合がある。', 'プロンプトの具体性で品質が変わる。', '商用前に掲載ルールを確認する必要がある。'],
    toolPros: ['重い編集作業なしで既存素材を直せる。', '複数画像をすばやく試せる。', 'OCRや商品登録前の前処理に向いている。', 'ブラウザ内で完結しやすい。'],
    toolCons: ['低解像度画像は補修品質が落ちる。', '複雑な背景は二度処理が必要なことがある。', '重要書類は必ず目視確認が必要。', '法務、学術、商用利用前は結果を検査する。'],
    modelPrompts: [{ title: '商品ビジュアル', text: '{title} 向けの清潔な商用商品画像、柔らかいスタジオ光、リアルな素材、明確な主体、EC向け構図。' }, { title: 'SNSカバー', text: '{title} を参考にしたSNSカバー、現代的なレイアウト、強い焦点、余白、上質なビジュアル。' }, { title: '広告コンセプト', text: '{title} の広告案、商品中心の構図、リアルな光、プレミアムなブランド感、読めない文字なし。' }],
    toolTips: [{ title: 'コピーで作業', text: '元ファイルを残し、複製で処理を試します。' }, { title: '細部を確認', text: '処理後に文字、端、影、背景の繰り返しを拡大確認します。' }, { title: '次のツールへ', text: '必要に応じて生成、透かし除去、手書き消去、文書補正へ進みます。' }],
    searchTerms: ['AI画像生成', 'AI画像ツール', 'プロンプト', 'オンライン画像編集', 'Miral']
  },
  ko: {
    profile: { headerHint: '실무 요점, 예시, 장단점, 다음 단계를 정리했습니다.', tldrLabel: '요약', tldrDesc: '적합한 용도를 먼저 확인한 뒤 아래 workflow를 따르세요.', faqLabel: 'FAQ', intentsLabel: '가이드', conclusionLabel: '다음', sideCtaKicker: '추천 진입', sideCtaDesc: '이 글의 체크리스트로 Miral에서 빠르게 테스트하세요.', navLabel: '이 글의 내용' },
    modelPros: ['브라우저에서 빠르게 테스트할 수 있습니다.', '여러 시각 방향을 쉽게 비교합니다.', '명확한 프롬프트와 상업 용도에 잘 맞습니다.', '필요하면 다른 Miral 모델로 전환하기 쉽습니다.'],
    modelCons: ['텍스트와 브랜드 디테일은 확인이 필요합니다.', '소재, 얼굴, 반사는 추가 시도가 필요할 수 있습니다.', '프롬프트 품질이 결과에 크게 영향을 줍니다.', '상업 사용 전 플랫폼 규칙을 확인해야 합니다.'],
    toolPros: ['무거운 편집 없이 기존 이미지를 고칠 수 있습니다.', '여러 소스 이미지를 빠르게 시험합니다.', 'OCR, 상품 등록, 후속 생성 전에 유용합니다.', '브라우저 안에서 작업을 이어가기 쉽습니다.'],
    toolCons: ['저해상도 파일은 품질이 제한됩니다.', '복잡한 배경은 두 번째 처리가 필요할 수 있습니다.', '중요 문서는 직접 검토해야 합니다.', '법무, 학업, 상업 용도 전 결과를 확인하세요.'],
    modelPrompts: [{ title: '제품 비주얼', text: '{title}용 깔끔한 상업 제품 이미지, 부드러운 스튜디오 조명, 사실적 소재, 명확한 주제, 이커머스 구도.' }, { title: '소셜 커버', text: '{title}에서 영감을 받은 소셜 커버, 현대적 레이아웃, 강한 초점, 균형 잡힌 여백, 고품질 스타일.' }, { title: '광고 콘셉트', text: '{title} 광고 콘셉트, 제품 중심 구도, 사실적 조명, 프리미엄 브랜드 분위기, 읽기 어려운 텍스트 없음.' }],
    toolTips: [{ title: '복사본으로 작업', text: '원본을 보관하고 복사본에서 먼저 테스트하세요.' }, { title: '작은 디테일 확인', text: '처리 후 글자, 가장자리, 그림자, 배경 패턴을 확대해 보세요.' }, { title: '다음 도구 선택', text: '필요하면 생성, 워터마크 제거, 손글씨 제거, 문서 보정으로 이어가세요.' }],
    searchTerms: ['AI 이미지 생성', 'AI 이미지 도구', '프롬프트 가이드', '온라인 이미지 편집', 'Miral']
  },
  fr: {
    profile: { headerHint: 'Inclut points pratiques, exemples, avantages, limites et prochaine étape.', tldrLabel: 'Résumé', tldrDesc: 'Vérifiez d’abord l’usage, puis suivez le workflow.', faqLabel: 'FAQ', intentsLabel: 'Guide', conclusionLabel: 'Suite', sideCtaKicker: 'Entrée recommandée', sideCtaDesc: 'Utilisez la checklist de l’article et testez dans Miral.', navLabel: 'Dans cet article' },
    modelSteps: [{ title: 'Définir l’usage', text: 'Précisez ecommerce, publicité, social, affiche, concept ou asset final.' }, { title: 'Décrire le sujet', text: 'Ajoutez produit, scène, lumière, style, angle, composition et format.' }, { title: 'Générer plusieurs pistes', text: 'Comparez quelques versions puis ajustez couleur, matière, fond ou mise en page.' }, { title: 'Vérifier avant usage', text: 'Contrôlez texte, logo, détails produit, mains, reflets et règles de plateforme.' }],
    toolSteps: [{ title: 'Importer une image test', text: 'Commencez par un exemple représentatif avant les fichiers importants.' }, { title: 'Marquer la zone', text: 'Sélectionnez précisément filigrane, écriture, bord, ombre ou déformation.' }, { title: 'Contrôler le résultat', text: 'Zoomez sur bords, petits textes, textures et zones réparées.' }, { title: 'Continuer le workflow', text: 'Utilisez l’image nettoyée pour génération, listing, OCR ou document.' }],
    searchTerms: ['générateur image IA', 'outil image IA', 'prompt IA', 'édition image en ligne', 'Miral']
  },
  es: {
    profile: { headerHint: 'Incluye puntos prácticos, ejemplos, ventajas, límites y siguiente paso.', tldrLabel: 'Resumen', tldrDesc: 'Comprueba primero el encaje y sigue el flujo.', faqLabel: 'FAQ', intentsLabel: 'Guía', conclusionLabel: 'Siguiente', sideCtaKicker: 'Entrada recomendada', sideCtaDesc: 'Usa la checklist del artículo y prueba en Miral.', navLabel: 'En este artículo' },
    searchTerms: ['generador de imágenes IA', 'herramienta de imagen IA', 'prompt IA', 'edición de imágenes online', 'Miral']
  },
  it: {
    profile: { headerHint: 'Include note pratiche, esempi, pro e contro e prossimo passo.', tldrLabel: 'Sintesi', tldrDesc: 'Controlla prima l’uso adatto, poi segui il workflow.', faqLabel: 'FAQ', intentsLabel: 'Guida', conclusionLabel: 'Prossimo', sideCtaKicker: 'Ingresso consigliato', sideCtaDesc: 'Usa la checklist dell’articolo e prova in Miral.', navLabel: 'In questo articolo' },
    searchTerms: ['generatore immagini IA', 'strumento immagini IA', 'prompt IA', 'editing immagini online', 'Miral']
  },
  de: {
    profile: { headerHint: 'Enthält praktische Hinweise, Beispiele, Vor- und Nachteile und den nächsten Schritt.', tldrLabel: 'Kurz', tldrDesc: 'Prüfe zuerst den Einsatzzweck und folge dann dem Ablauf.', faqLabel: 'FAQ', intentsLabel: 'Guide', conclusionLabel: 'Weiter', sideCtaKicker: 'Empfohlener Einstieg', sideCtaDesc: 'Nutze die Checkliste und teste direkt in Miral.', navLabel: 'In diesem Artikel' },
    searchTerms: ['KI Bildgenerator', 'KI Bildtool', 'Prompt Guide', 'Bild online bearbeiten', 'Miral']
  },
  pt: {
    profile: { headerHint: 'Inclui pontos práticos, exemplos, prós e contras e próximo passo.', tldrLabel: 'Resumo', tldrDesc: 'Confira primeiro o uso ideal e siga o fluxo.', faqLabel: 'FAQ', intentsLabel: 'Guia', conclusionLabel: 'Próximo', sideCtaKicker: 'Entrada recomendada', sideCtaDesc: 'Use a checklist do artigo e teste no Miral.', navLabel: 'Neste artigo' },
    searchTerms: ['gerador de imagens IA', 'ferramenta de imagem IA', 'prompt IA', 'edição de imagem online', 'Miral']
  },
  pl: {
    profile: { headerHint: 'Zawiera praktyczne wskazówki, przykłady, plusy, minusy i następny krok.', tldrLabel: 'Skrót', tldrDesc: 'Najpierw sprawdź zastosowanie, potem wykonaj workflow.', faqLabel: 'FAQ', intentsLabel: 'Poradnik', conclusionLabel: 'Dalej', sideCtaKicker: 'Polecany start', sideCtaDesc: 'Użyj checklisty i przetestuj w Miral.', navLabel: 'W tym artykule' },
    searchTerms: ['generator obrazów AI', 'narzędzie obrazów AI', 'prompt AI', 'edycja obrazów online', 'Miral']
  },
  ar: {
    profile: { headerHint: 'يتضمن نقاطًا عملية وأمثلة ومزايا وقيودًا وخطوة تالية.', tldrLabel: 'ملخص', tldrDesc: 'تحقق من ملاءمة الاستخدام أولًا ثم اتبع سير العمل.', faqLabel: 'FAQ', intentsLabel: 'دليل', conclusionLabel: 'التالي', sideCtaKicker: 'مدخل موصى به', sideCtaDesc: 'استخدم قائمة التحقق في المقال وجرب في Miral.', navLabel: 'في هذا المقال' },
    searchTerms: ['مولد صور بالذكاء الاصطناعي', 'أداة صور بالذكاء الاصطناعي', 'مطالبات AI', 'تحرير الصور عبر الإنترنت', 'Miral']
  }
}

var PACKS = {
  en: BASE,
  ja: {
    sections: { tldr: '短い答え', overview: 'このガイドの内容', workflow: 'おすすめの流れ', prompts: 'プロンプト例', tips: '実用メモ', prosCons: 'メリットとデメリット', compare: 'どのモデルが合うか', nextSteps: '次にやること', faq: 'よくある質問', conclusion: 'まとめと次のステップ' },
    table: { columns: ['項目', 'ガイド'], bestFor: '向いている用途', watch: '確認ポイント', workflow: '流れ', next: '次の操作', modelBest: 'AI画像生成、商品ビジュアル、広告案、SNSカバー、プロンプト検証。', toolBest: '既存画像、書類写真、スキャン、商品素材をきれいにする作業。', modelWatch: '公開前に文字、ブランド要素、商品細部、プラットフォーム要件を確認します。', toolWatch: 'できるだけ鮮明な元画像を使い、端、影、小さな文字を確認します。', modelWorkflow: '広めに生成し、良い方向を選んでからプロンプトやモデルを調整します。', toolWorkflow: 'テスト画像をアップロードし、問題箇所を指定して結果を確認します。' },
    modelSteps: [{ title: '用途を決める', text: 'EC、広告、SNS、ポスター、コンセプト、納品素材のどれかを先に決めます。' }, { title: '主体を具体的に書く', text: '商品、背景、光、スタイル、角度、構図、比率を入れます。' }, { title: '複数案を出す', text: '数枚生成して、色、素材、背景、レイアウトを調整します。' }, { title: '納品前に確認する', text: '文字、ロゴ、商品細部、手、反射、掲載ルールを見直します。' }],
    toolSteps: [{ title: 'テスト画像を上げる', text: '重要なファイルの前に代表的な1枚で品質を確認します。' }, { title: '問題箇所を指定する', text: '透かし、手書き、端、影、ゆがみをできるだけ正確に選びます。' }, { title: '結果を確認する', text: '端、小さな文字、背景補修、繰り返し模様を拡大して見ます。' }, { title: '次の作業へ進む', text: '生成、商品登録、OCR、資料化など次の工程に使います。' }],
    conclusion: { paragraph: '{title} は魔法のボタンではなく、作業を早く進めるための実用ステップです。用途に合わせて結果を確認してください。', bullets: ['用途をひとつに絞る。', '小さなテストから始める。', '公開や書き出し前に品質を見る。', '準備できたら {target} を開く。'], ctaTitle: 'Miralで試す', ctaText: 'この記事をチェックリストとして使い、対応するMiral機能で試してください。' }
  },
  ko: {
    sections: { tldr: '빠른 요약', overview: '가이드 내용', workflow: '추천 workflow', prompts: '프롬프트 예시', tips: '실무 팁', prosCons: '장단점', compare: '어떤 모델이 맞는지', nextSteps: '다음에 할 일', faq: 'FAQ', conclusion: '정리와 다음 단계' },
    table: { columns: ['항목', '가이드'], bestFor: '적합한 용도', watch: '확인할 점', workflow: '흐름', next: '다음 단계', modelBest: 'AI 이미지 생성, 제품 장면, 광고 시안, 소셜 커버, 프롬프트 테스트.', toolBest: '기존 이미지, 문서 사진, 스캔, 제품 소스를 정리하는 작업.', modelWatch: '상업 사용 전 텍스트, 브랜드 요소, 제품 디테일, 플랫폼 규칙을 확인하세요.', toolWatch: '가능하면 선명한 원본을 쓰고 가장자리, 그림자, 작은 글자를 점검하세요.', modelWorkflow: '넓게 생성한 뒤 좋은 방향을 고르고 프롬프트나 모델을 조정합니다.', toolWorkflow: '테스트 이미지를 업로드하고 문제 영역을 표시한 뒤 결과를 확인합니다.' },
    modelSteps: [{ title: '용도 정하기', text: '이커머스, 광고, 소셜, 포스터, 콘셉트, 납품용 중 무엇인지 먼저 정합니다.' }, { title: '주제를 구체화하기', text: '제품, 배경, 조명, 스타일, 시점, 구도, 비율을 함께 적습니다.' }, { title: '여러 방향 만들기', text: '몇 가지 버전을 만든 뒤 색상, 소재, 배경, 레이아웃을 다듬습니다.' }, { title: '사용 전 검수하기', text: '텍스트, 로고, 제품 세부, 손, 반사, 게시 규칙을 확인합니다.' }],
    toolSteps: [{ title: '테스트 이미지 업로드', text: '중요 파일 전에 대표 이미지 한 장으로 품질을 확인합니다.' }, { title: '문제 영역 표시', text: '워터마크, 손글씨, 가장자리, 그림자, 왜곡 영역을 최대한 정확히 선택합니다.' }, { title: '결과 확인', text: '가장자리, 작은 글자, 배경 복원, 반복 패턴을 확대해 봅니다.' }, { title: '다음 작업으로 이동', text: '생성, 상품 등록, OCR, 문서 정리에 이어 사용할 수 있습니다.' }],
    conclusion: { paragraph: '{title}는 마법 버튼이 아니라 작업 속도를 높이는 실무 단계입니다. 실제 사용처에 맞춰 결과를 검수하세요.', bullets: ['용도를 하나로 정합니다.', '작은 테스트부터 시작합니다.', '공개 또는 내보내기 전에 품질을 확인합니다.', '준비되면 {target}를 엽니다.'], ctaTitle: 'Miral에서 테스트', ctaText: '이 글을 체크리스트로 삼아 해당 Miral 기능에서 바로 테스트하세요.' }
  },
  fr: {
    sections: { tldr: 'Résumé rapide', overview: 'Ce que couvre ce guide', workflow: 'Workflow conseillé', prompts: 'Exemples de prompts', tips: 'Conseils pratiques', prosCons: 'Avantages et limites', compare: 'Quel modèle convient', nextSteps: 'Etape suivante utile', faq: 'FAQ', conclusion: 'Conclusion et étape suivante' },
    table: { columns: ['Élément', 'Conseil'], bestFor: 'Idéal pour', watch: 'À vérifier', workflow: 'Workflow', next: 'Étape suivante', modelBest: 'Génération d’images IA, visuels produit, concepts publicitaires, couvertures sociales et tests de prompts.', toolBest: 'Nettoyage d’images existantes, photos de documents, scans et visuels produit.', modelWatch: 'Vérifiez le texte, les éléments de marque, les détails produit et les règles de plateforme avant publication.', toolWatch: 'Utilisez une source nette et inspectez les bords, ombres et petits textes.', modelWorkflow: 'Commencez large, générez plusieurs versions, puis ajustez le prompt ou le modèle.', toolWorkflow: 'Importez une image test, marquez la zone, contrôlez le résultat puis traitez le fichier final.' },
    conclusion: { paragraph: '{title} doit être vu comme une étape de workflow pratique. Avancez vite, puis vérifiez le résultat selon sa destination réelle.', bullets: ['Commencez par un cas d’usage clair.', 'Faites d’abord un petit test.', 'Contrôlez la qualité avant publication ou export.', 'Ouvrez {target} quand vous êtes prêt.'], ctaTitle: 'Essayer dans Miral', ctaText: 'Utilisez cet article comme checklist et lancez un premier test dans Miral.' }
  },
  es: {
    sections: { tldr: 'Resumen rápido', overview: 'Qué cubre esta guía', workflow: 'Flujo recomendado', prompts: 'Ejemplos de prompts', tips: 'Consejos prácticos', prosCons: 'Ventajas y límites', compare: 'Qué modelo encaja', nextSteps: 'Qué hacer después', faq: 'Preguntas frecuentes', conclusion: 'Conclusión y siguiente paso' },
    table: { columns: ['Punto', 'Guía'], bestFor: 'Ideal para', watch: 'Revisar', workflow: 'Flujo', next: 'Siguiente paso', modelBest: 'Generación de imágenes IA, visuales de producto, anuncios, portadas sociales y pruebas de prompts.', toolBest: 'Limpieza de imágenes existentes, fotos de documentos, escaneos y recursos de producto.', modelWatch: 'Revisa texto, marca, detalles del producto y reglas de la plataforma antes de publicar.', toolWatch: 'Usa una fuente clara y revisa bordes, sombras y texto pequeño.', modelWorkflow: 'Empieza amplio, genera varias versiones y ajusta el prompt o el modelo.', toolWorkflow: 'Sube una imagen de prueba, marca la zona, revisa el resultado y procesa el archivo final.' },
    conclusion: { paragraph: '{title} funciona mejor como un paso práctico de flujo de trabajo. Avanza rápido y revisa el resultado según el destino real.', bullets: ['Empieza con un caso de uso claro.', 'Haz primero una prueba pequeña.', 'Revisa la calidad antes de publicar o exportar.', 'Abre {target} cuando estés listo.'], ctaTitle: 'Probar en Miral', ctaText: 'Usa este artículo como checklist y realiza una primera prueba en Miral.' }
  },
  it: {
    sections: { tldr: 'Sintesi rapida', overview: 'Cosa copre questa guida', workflow: 'Workflow consigliato', prompts: 'Esempi di prompt', tips: 'Consigli pratici', prosCons: 'Pro e contro', compare: 'Quale modello usare', nextSteps: 'Cosa fare dopo', faq: 'FAQ', conclusion: 'Conclusione e passo successivo' },
    table: { columns: ['Voce', 'Indicazione'], bestFor: 'Ideale per', watch: 'Da controllare', workflow: 'Workflow', next: 'Passo successivo', modelBest: 'Generazione immagini IA, visual prodotto, concept pubblicitari, cover social e test prompt.', toolBest: 'Pulizia di immagini esistenti, foto documenti, scansioni e asset prodotto.', modelWatch: 'Controlla testo, brand, dettagli prodotto e regole piattaforma prima della pubblicazione.', toolWatch: 'Usa una fonte nitida e verifica bordi, ombre e testi piccoli.', modelWorkflow: 'Parti largo, genera più versioni e poi regola prompt o modello.', toolWorkflow: 'Carica un’immagine test, marca l’area, controlla il risultato e lavora sul file finale.' },
    conclusion: { paragraph: '{title} va trattato come una fase pratica del workflow. Procedi veloce, poi controlla il risultato in base alla destinazione.', bullets: ['Parti da un caso d’uso chiaro.', 'Fai prima un piccolo test.', 'Controlla la qualità prima di pubblicare o esportare.', 'Apri {target} quando sei pronto.'], ctaTitle: 'Prova in Miral', ctaText: 'Usa l’articolo come checklist e fai un primo test in Miral.' }
  },
  de: {
    sections: { tldr: 'Kurzfazit', overview: 'Was dieser Guide abdeckt', workflow: 'Empfohlener Ablauf', prompts: 'Prompt-Beispiele', tips: 'Praxistipps', prosCons: 'Vor- und Nachteile', compare: 'Welches Modell passt', nextSteps: 'Nächster sinnvoller Schritt', faq: 'FAQ', conclusion: 'Fazit und nächster Schritt' },
    table: { columns: ['Punkt', 'Hinweis'], bestFor: 'Am besten für', watch: 'Prüfen', workflow: 'Ablauf', next: 'Nächster Schritt', modelBest: 'KI-Bildgenerierung, Produktvisuals, Anzeigenentwürfe, Social Cover und Prompt-Tests.', toolBest: 'Bereinigung vorhandener Bilder, Dokumentfotos, Scans und Produktmaterial.', modelWatch: 'Prüfe Text, Markendetails, Produktdetails und Plattformregeln vor Veröffentlichung.', toolWatch: 'Nutze eine klare Quelle und prüfe Kanten, Schatten und kleine Schrift.', modelWorkflow: 'Starte breit, generiere mehrere Versionen und passe dann Prompt oder Modell an.', toolWorkflow: 'Lade ein Testbild hoch, markiere den Bereich, prüfe das Ergebnis und verarbeite die finale Datei.' },
    conclusion: { paragraph: '{title} ist ein praktischer Workflow-Schritt, kein Zauberknopf. Arbeite schnell, prüfe das Ergebnis aber für den echten Einsatz.', bullets: ['Beginne mit einem klaren Use Case.', 'Teste zuerst klein.', 'Prüfe Qualität vor Veröffentlichung oder Export.', 'Öffne {target}, wenn du bereit bist.'], ctaTitle: 'In Miral testen', ctaText: 'Nutze den Artikel als Checkliste und starte einen ersten Test in Miral.' }
  },
  pt: {
    sections: { tldr: 'Resumo rápido', overview: 'O que este guia cobre', workflow: 'Fluxo recomendado', prompts: 'Exemplos de prompts', tips: 'Dicas práticas', prosCons: 'Prós e contras', compare: 'Qual modelo encaixa', nextSteps: 'O que fazer em seguida', faq: 'FAQ', conclusion: 'Conclusão e próximo passo' },
    table: { columns: ['Item', 'Orientação'], bestFor: 'Melhor para', watch: 'Atenção', workflow: 'Fluxo', next: 'Próximo passo', modelBest: 'Geração de imagens IA, visuais de produto, anúncios, capas sociais e testes de prompt.', toolBest: 'Limpeza de imagens existentes, fotos de documentos, scans e materiais de produto.', modelWatch: 'Revise texto, marca, detalhes do produto e regras da plataforma antes de publicar.', toolWatch: 'Use uma fonte nítida e confira bordas, sombras e textos pequenos.', modelWorkflow: 'Comece amplo, gere versões e ajuste prompt ou modelo.', toolWorkflow: 'Envie uma imagem teste, marque a área, revise o resultado e processe o arquivo final.' },
    conclusion: { paragraph: '{title} funciona melhor como etapa prática de workflow. Avance rápido e revise o resultado conforme o destino real.', bullets: ['Comece com um caso de uso claro.', 'Faça primeiro um teste pequeno.', 'Confira a qualidade antes de publicar ou exportar.', 'Abra {target} quando estiver pronto.'], ctaTitle: 'Testar no Miral', ctaText: 'Use o artigo como checklist e faça um primeiro teste no Miral.' }
  },
  pl: {
    sections: { tldr: 'Szybkie podsumowanie', overview: 'Zakres poradnika', workflow: 'Zalecany workflow', prompts: 'Przykłady promptów', tips: 'Praktyczne wskazówki', prosCons: 'Zalety i wady', compare: 'Który model pasuje', nextSteps: 'Co zrobić dalej', faq: 'FAQ', conclusion: 'Wniosek i następny krok' },
    table: { columns: ['Element', 'Wskazówka'], bestFor: 'Najlepsze do', watch: 'Sprawdź', workflow: 'Workflow', next: 'Następny krok', modelBest: 'Generowanie obrazów AI, wizualizacje produktu, reklamy, okładki social i testy promptów.', toolBest: 'Czyszczenie istniejących zdjęć, fotografii dokumentów, skanów i materiałów produktowych.', modelWatch: 'Sprawdź tekst, markę, szczegóły produktu i zasady platformy przed publikacją.', toolWatch: 'Użyj wyraźnego źródła i sprawdź krawędzie, cienie oraz mały tekst.', modelWorkflow: 'Zacznij szeroko, wygeneruj kilka wersji i dopracuj prompt lub model.', toolWorkflow: 'Wgraj obraz testowy, zaznacz obszar, sprawdź wynik i przetwórz finalny plik.' },
    conclusion: { paragraph: '{title} to praktyczny krok workflow, nie magiczny przycisk. Działaj szybko, ale sprawdzaj wynik pod realne użycie.', bullets: ['Zacznij od jednego jasnego celu.', 'Najpierw wykonaj mały test.', 'Sprawdź jakość przed publikacją lub eksportem.', 'Otwórz {target}, gdy jesteś gotowy.'], ctaTitle: 'Przetestuj w Miral', ctaText: 'Użyj artykułu jako checklisty i uruchom pierwszy test w Miral.' }
  },
  ar: {
    sections: { tldr: 'خلاصة سريعة', overview: 'ما الذي يغطيه الدليل', workflow: 'سير العمل المقترح', prompts: 'أمثلة مطالبات', tips: 'نصائح عملية', prosCons: 'المزايا والعيوب', compare: 'أي نموذج يناسبك', nextSteps: 'ماذا تفعل بعد ذلك', faq: 'أسئلة شائعة', conclusion: 'الخلاصة والخطوة التالية' },
    table: { columns: ['العنصر', 'الإرشاد'], bestFor: 'الأفضل لـ', watch: 'تحقق من', workflow: 'سير العمل', next: 'الخطوة التالية', modelBest: 'توليد صور بالذكاء الاصطناعي، مشاهد منتجات، إعلانات، أغلفة اجتماعية، واختبار المطالبات.', toolBest: 'تنظيف الصور الموجودة، صور المستندات، المسح الضوئي، ومواد المنتجات.', modelWatch: 'راجع النص والعلامة التجارية وتفاصيل المنتج وقواعد المنصة قبل النشر.', toolWatch: 'استخدم صورة واضحة وتحقق من الحواف والظلال والنصوص الصغيرة.', modelWorkflow: 'ابدأ بشكل واسع، أنشئ عدة نسخ، ثم عدّل المطالبة أو النموذج.', toolWorkflow: 'ارفع صورة اختبار، حدّد المنطقة، راجع النتيجة، ثم عالج الملف النهائي.' },
    conclusion: { paragraph: '{title} خطوة عملية في سير العمل وليست زرًا سحريًا. تحرك بسرعة، ثم راجع النتيجة حسب الاستخدام الفعلي.', bullets: ['ابدأ بحالة استخدام واضحة.', 'جرّب ملفًا صغيرًا أولًا.', 'تحقق من الجودة قبل النشر أو التصدير.', 'افتح {target} عندما تكون جاهزًا.'], ctaTitle: 'جرّب في Miral', ctaText: 'استخدم المقال كقائمة تحقق وابدأ تجربة أولى في Miral.' }
  }
}

function merge(base, patch) {
  var out = Object.assign({}, base || {})
  var key
  for (key in (patch || {})) {
    if (
      patch[key] &&
      typeof patch[key] === 'object' &&
      !Array.isArray(patch[key]) &&
      base[key] &&
      typeof base[key] === 'object' &&
      !Array.isArray(base[key])
    ) {
      out[key] = merge(base[key], patch[key])
    } else {
      out[key] = patch[key]
    }
  }
  return out
}

function getPack(locale) {
  if (locale === 'zh') return null
  var pack = merge(merge(BASE, PACKS[locale] || BASE), COMMON_LOCALE_CONTENT[locale] || {})
  pack._locale = locale
  return pack
}

function isToolArticle(article) {
  return !!(article && article.target && article.target.path && article.target.path.indexOf('/tools/') === 0)
}

function getArticleData(article) {
  return {
    title: article.title,
    excerpt: article.excerpt,
    target: article.target && article.target.label ? article.target.label : '',
    path: article.target && article.target.path ? article.target.path : ''
  }
}

function buildRows(pack, isTool, data) {
  var t = pack.table
  return [
    [t.bestFor, isTool ? t.toolBest : t.modelBest],
    [t.watch, isTool ? t.toolWatch : t.modelWatch],
    [t.workflow, isTool ? t.toolWorkflow : t.modelWorkflow],
    [t.next, data.target]
  ]
}

function buildPromptBlocks(pack, data, targetCount, media, locale, slug, localeBody) {
  var source = null
  if (localeBody && localeBody.promptExamples && localeBody.promptExamples.length) {
    source = localeBody.promptExamples.map(function (item) {
      return { title: item.label, text: item.prompt, imageKey: item.imageKey || '' }
    })
  }
  if (!source && slug && locale && locale !== 'zh') {
    var catalog = promptCatalog.getPromptExamples(slug, locale)
    if (catalog && catalog.length) {
      source = catalog.map(function (item) {
        return { title: item.label, text: item.prompt, imageKey: item.imageKey || '' }
      })
    }
  }
  if (!source && (pack._locale === 'en' || pack.modelPrompts !== BASE.modelPrompts)) {
    source = pack.modelPrompts
  }
  if (!source) {
    source = [
      { title: pack.sections.prompts + ' 1', text: data.title + ' - ' + pack.table.modelBest },
      { title: pack.sections.prompts + ' 2', text: data.title + ' - ' + pack.table.modelWorkflow },
      { title: pack.sections.prompts + ' 3', text: data.title + ' - ' + pack.table.modelWatch }
    ]
  }
  var fallback = [
    { title: pack.sections.compare, text: data.title + ' - ' + (pack.profile || BASE.profile).sideCtaDesc },
    { title: pack.table.next, text: data.title + ' - ' + data.target },
    { title: pack.sections.overview, text: data.title + ' - ' + fmt((pack.overview || BASE.overview)[1], data) },
    { title: (pack.profile || BASE.profile).sideCtaKicker, text: data.title + ' - ' + (pack.profile || BASE.profile).headerHint },
    { title: pack.sections.conclusion, text: data.title + ' - ' + fmt((pack.conclusion || BASE.conclusion).paragraph, data) }
  ]
  var fi = 0
  while (source.length < targetCount) {
    source.push(fallback[fi % fallback.length])
    fi++
  }
  var blocks = source.map(function (item) {
    var block = promptExample(fmt(item.title, data), fmt(item.text, data))
    if (item.imageKey) block.imageKey = item.imageKey
    return block
  })
  var promptImages = media && media.promptImages ? media.promptImages : []
  var i
  for (i = 0; i < blocks.length; i++) {
    if (blocks[i].imageKey) continue
    if (i < promptImages.length) blocks[i].imageKey = promptImages[i]
  }
  return blocks
}

function buildTipBlocks(pack, data, targetCount, localeBody) {
  var source = null
  if (localeBody && localeBody.tips && localeBody.tips.length) {
    source = localeBody.tips
  } else if (pack._locale === 'en' || pack.toolTips !== BASE.toolTips) {
    source = pack.toolTips
  }
  source = source || [
    { title: pack.table.bestFor, text: pack.table.toolBest },
    { title: pack.table.watch, text: pack.table.toolWatch },
    { title: pack.table.next, text: data.target }
  ]
  var fallback = [
    { title: pack.table.workflow, text: pack.table.toolWorkflow },
    { title: pack.sections.overview, text: fmt((pack.overview || BASE.overview)[0], data) },
    { title: pack.sections.compare, text: (pack.profile || BASE.profile).tldrDesc },
    { title: pack.table.next, text: data.target }
  ]
  var fi = 0
  while (source.length < targetCount) {
    source.push(fallback[fi % fallback.length])
    fi++
  }
  return source.map(function (item) {
    return tip(fmt(item.title, data), fmt(item.text, data))
  })
}

function buildFaqBlocks(pack, isTool, data) {
  var source = isTool ? (pack.toolFaq || BASE.toolFaq) : (pack.modelFaq || BASE.modelFaq)
  return source.map(function (item) {
    return faqItem(fmt(item.q, data), fmt(item.a, data))
  })
}

function buildToolScenarioSection(pack, data, localeBody, locale, targetCount) {
  var copy = TOOL_SCENARIO_COPY[locale] || TOOL_SCENARIO_COPY.en
  var source = []
  var faqSource = localeBody && localeBody.scenarios && localeBody.scenarios.length
    ? localeBody.scenarios
    : (pack.toolFaq || BASE.toolFaq)
  faqSource.forEach(function (item) {
    source.push({ title: item.title || item.q, text: item.text || item.a })
  })
  ;(localeBody && localeBody.tips && localeBody.tips.length ? localeBody.tips : (pack.toolTips || BASE.toolTips)).forEach(function (item) {
    source.push(item)
  })
  if (!localeBody || !localeBody.steps || !localeBody.steps.length) {
    ;(pack.toolSteps || BASE.toolSteps).forEach(function (item) {
      source.push(item)
    })
  }
  source.push(
    { title: pack.table.bestFor, text: pack.table.toolBest },
    { title: pack.table.watch, text: pack.table.toolWatch },
    { title: pack.table.workflow, text: pack.table.toolWorkflow },
    { title: pack.table.next, text: data.target },
    { title: pack.sections.conclusion, text: (pack.conclusion || BASE.conclusion).paragraph },
    { title: (pack.profile || BASE.profile).sideCtaKicker, text: (pack.profile || BASE.profile).sideCtaDesc }
  )
  source = source.slice(0, targetCount || source.length)
  var blocks = [p(localeBody && localeBody.scenarioIntro ? localeBody.scenarioIntro : copy.intro)]
  source.forEach(function (item) {
    blocks.push(scenarioItem(
      fmt(item.title, data),
      fmt(item.text, data)
    ))
  })
  return section('search-intents', copy.title, blocks)
}

function buildModelScenarioSection(pack, data, localeBody, locale, targetCount) {
  var copy = MODEL_SCENARIO_COPY[locale] || MODEL_SCENARIO_COPY.en
  var source = []
  var faqSource = localeBody && localeBody.scenarios && localeBody.scenarios.length
    ? localeBody.scenarios
    : (pack.modelFaq || BASE.modelFaq)
  faqSource.forEach(function (item) {
    source.push({ title: item.title || item.q, text: item.text || item.a })
  })
  ;(pack.modelPrompts || BASE.modelPrompts).forEach(function (item) {
    source.push(item)
  })
  ;(pack.modelSteps || BASE.modelSteps).forEach(function (item) {
    source.push(item)
  })
  source.push(
    { title: pack.table.bestFor, text: pack.table.modelBest },
    { title: pack.table.watch, text: pack.table.modelWatch },
    { title: pack.table.workflow, text: pack.table.modelWorkflow },
    { title: pack.table.next, text: data.target },
    { title: pack.sections.conclusion, text: (pack.conclusion || BASE.conclusion).paragraph },
    { title: (pack.profile || BASE.profile).sideCtaKicker, text: (pack.profile || BASE.profile).sideCtaDesc }
  )
  source = source.slice(0, targetCount || source.length)
  var blocks = [p(copy.intro)]
  source.forEach(function (item) {
    blocks.push(scenarioItem(fmt(item.title, data), fmt(item.text, data)))
  })
  return section('search-intents', copy.title, blocks)
}

function getScenarioTerms(pack, data) {
  var base = [
    data.target,
    data.title,
    pack.table.bestFor,
    pack.table.workflow,
    pack.table.watch,
    pack.table.next,
    pack.sections.overview,
    pack.sections.compare,
    pack.sections.prompts,
    pack.sections.tips,
    pack.sections.conclusion
  ]
  return base.concat(pack.searchTerms || BASE.searchTerms).filter(Boolean)
}

function buildPlatformRows(pack, isTool, data) {
  var terms = getScenarioTerms(pack, data).slice(0, 10)
  var rows = []
  var i
  for (i = 0; i < terms.length; i++) {
    rows.push([
      terms[i],
      i % 3 === 0
        ? (isTool ? pack.table.toolBest : pack.table.modelBest)
        : (i % 3 === 1 ? (isTool ? pack.table.toolWorkflow : pack.table.modelWorkflow) : (isTool ? pack.table.toolWatch : pack.table.modelWatch))
    ])
  }
  return rows
}

function buildPracticeBlocks(pack, isTool, data, media, localeBody) {
  var overview = pack.overview || BASE.overview
  var blocks = [
    p(fmt(overview[0], data)),
    p(fmt(overview[2], data)),
    table(pack.table.columns, buildRows(pack, isTool, data), 'overview')
  ]
  if (localeBody && localeBody.practice && localeBody.practice.length) {
    localeBody.practice.forEach(function (item) {
      blocks.splice(blocks.length - 1, 0, p(fmt(item, data)))
    })
  }
  if (media && media.gallery && media.gallery.imageKeys && media.gallery.imageKeys.length) {
    blocks.push(gallery(media.gallery.imageKeys, data.title, media.gallery.cols, media.gallery.fit, media.gallery.ratio))
  } else if (media && media.figure) {
    blocks.push(figure(media.figure, data.title, data.title))
  }
  return blocks
}

function buildCompareBlocks(pack, isTool, data, media, locale, localeBody) {
  var copyPack = RELATED_COMPARISON_COPY[locale] || RELATED_COMPARISON_COPY.en
  var comparisonText = (pack.profile || BASE.profile).tldrDesc
  if (localeBody && localeBody.compareIntro) {
    comparisonText = fmt(localeBody.compareIntro, data)
  } else if (media && media.relatedLinks && media.relatedLinks.length) {
    comparisonText = fmt(isTool ? copyPack.tool : copyPack.model, {
      links: media.relatedLinks.map(function (item) { return item.label }).join(', ')
    })
  }
  var blocks = [
    p(comparisonText),
    table(pack.table.columns, buildPlatformRows(pack, isTool, data).slice(0, 6), 'overview'),
    cta((pack.profile || BASE.profile).sideCtaKicker, (pack.profile || BASE.profile).sideCtaDesc, data.target, data.path)
  ]
  if (media && media.relatedLinks && media.relatedLinks.length) {
    blocks.push(links(RELATED_LINK_TITLES[locale] || RELATED_LINK_TITLES.en, media.relatedLinks))
  }
  return blocks
}

function padTextList(list, targetCount, fallbackItems, data) {
  var out = (list || []).slice()
  var i = 0
  while (out.length < targetCount) {
    out.push(fallbackItems[i % fallbackItems.length])
    i++
  }
  return fillList(out.slice(0, targetCount), data)
}

function buildLayoutProfile(pack) {
  var profile = pack.profile || BASE.profile
  return {
    headerHint: profile.headerHint,
    tldrLabel: profile.tldrLabel,
    tldrTitle: pack.sections.tldr,
    tldrDesc: profile.tldrDesc,
    faqLabel: profile.faqLabel,
    faqTitle: pack.sections.faq,
    intentsLabel: profile.intentsLabel,
    conclusionLabel: profile.conclusionLabel,
    conclusionTitle: pack.sections.conclusion,
    sideCtaKicker: profile.sideCtaKicker,
    sideCtaDesc: profile.sideCtaDesc,
    navLabel: profile.navLabel
  }
}

function buildArticleContent(locale, article) {
  var pack = getPack(locale)
  if (!pack || !article) return null
  var isTool = isToolArticle(article)
  var localeBody = getArticleBody(article, locale)
  pack = resolveArticlePack(pack, localeBody, isTool)
  var target = getAlignmentTarget(article, isTool)
  var data = getArticleData(article)
  var media = collectArticleMedia(article)
  var fallbackSteps = isTool
    ? [
        { title: pack.table.bestFor, text: pack.table.toolBest },
        { title: pack.table.workflow, text: pack.table.toolWorkflow },
        { title: pack.table.watch, text: pack.table.toolWatch },
        { title: pack.table.next, text: data.target },
        { title: pack.sections.compare, text: (pack.profile || BASE.profile).sideCtaDesc }
      ]
    : [
        { title: pack.table.bestFor, text: pack.table.modelBest },
        { title: pack.table.workflow, text: pack.table.modelWorkflow },
        { title: pack.table.watch, text: pack.table.modelWatch },
        { title: pack.table.next, text: data.target },
        { title: pack.sections.compare, text: (pack.profile || BASE.profile).sideCtaDesc }
      ]
  var fallbackPros = isTool
    ? [pack.table.toolBest, pack.table.toolWorkflow, (pack.profile || BASE.profile).sideCtaDesc, data.target, (pack.profile || BASE.profile).tldrDesc]
    : [pack.table.modelBest, pack.table.modelWorkflow, (pack.profile || BASE.profile).sideCtaDesc, data.target, (pack.profile || BASE.profile).tldrDesc]
  var fallbackCons = isTool
    ? [pack.table.toolWatch, pack.table.watch, (pack.profile || BASE.profile).tldrDesc, (pack.conclusion || BASE.conclusion).paragraph]
    : [pack.table.modelWatch, pack.table.watch, (pack.profile || BASE.profile).tldrDesc, (pack.conclusion || BASE.conclusion).paragraph]
  var modelSteps = pack._locale === 'en' || pack.modelSteps !== BASE.modelSteps ? pack.modelSteps : null
  var toolSteps = pack._locale === 'en' || pack.toolSteps !== BASE.toolSteps ? pack.toolSteps : null
  var modelPros = pack._locale === 'en' || pack.modelPros !== BASE.modelPros ? pack.modelPros : null
  var toolPros = pack._locale === 'en' || pack.toolPros !== BASE.toolPros ? pack.toolPros : null
  var modelCons = pack._locale === 'en' || pack.modelCons !== BASE.modelCons ? pack.modelCons : null
  var toolCons = pack._locale === 'en' || pack.toolCons !== BASE.toolCons ? pack.toolCons : null
  var steps = padTextList(isTool ? (toolSteps || fallbackSteps) : (modelSteps || fallbackSteps), target.steps, fallbackSteps, data)
  var pros = padTextList(isTool ? (toolPros || fallbackPros) : (modelPros || fallbackPros), target.pros, fallbackPros, data)
  var cons = padTextList(isTool ? (toolCons || fallbackCons) : (modelCons || fallbackCons), target.cons, fallbackCons, data)
  if (localeBody && localeBody.steps && localeBody.steps.length) {
    steps = padTextList(localeBody.steps, target.steps, fallbackSteps, data)
  }
  if (localeBody && localeBody.pros && localeBody.pros.length) {
    pros = padTextList(localeBody.pros, target.pros, fallbackPros, data)
  }
  if (localeBody && localeBody.cons && localeBody.cons.length) {
    cons = padTextList(localeBody.cons, target.cons, fallbackCons, data)
  }
  var conclusion = pack.conclusion || BASE.conclusion
  var profile = pack.profile || BASE.profile
  var scenarioTitle = profile.intentsLabel + ': ' + (isTool ? pack.sections.tips : pack.sections.overview)
  var platformTitle = pack.table.bestFor + ' / ' + pack.table.workflow
  var sections = [
    section('tldr', pack.sections.tldr, [
      table(pack.table.columns, buildRows(pack, isTool, data), 'overview'),
      p(fmt(isTool ? pack.table.toolWorkflow : pack.table.modelWorkflow, data))
    ]),
    section('overview', pack.sections.overview, fillList(pack.overview, data).map(function (item) {
      return p(item)
    })),
    section('how-i-tested', pack.table.workflow, buildPracticeBlocks(pack, isTool, data, media, localeBody)),
    section('workflow', pack.sections.workflow, [
      p(fmt(isTool ? pack.table.toolWorkflow : pack.table.modelWorkflow, data)),
      stepsBlock()
    ]),
    section(isTool ? 'common-use-cases' : 'common-scenarios', scenarioTitle, [
      p(profile.headerHint),
      table(pack.table.columns, buildPlatformRows(pack, isTool, data).slice(0, 8), 'overview')
    ]),
    section(isTool ? 'tips' : 'prompt-examples', isTool ? pack.sections.tips : pack.sections.prompts, isTool ? buildTipBlocks(pack, data, target.prompts, localeBody) : buildPromptBlocks(pack, data, target.prompts, media, locale, article.slug, localeBody)),
    section('pros-cons', pack.sections.prosCons || pack.sections.compare, [
      prosConsBlock()
    ]),
    section(isTool ? 'best-practices' : 'model-pick', isTool ? (pack.sections.nextSteps || pack.sections.compare) : pack.sections.compare, buildCompareBlocks(pack, isTool, data, media, locale, localeBody)),
    section('platform-ref', platformTitle, [
      p(isTool ? pack.table.toolBest : pack.table.modelBest),
      table(pack.table.columns, buildPlatformRows(pack, isTool, data), 'overview')
    ]),
    section('conclusion', pack.sections.conclusion, [
      p(fmt(conclusion.paragraph, data)),
      bullets(fillList(conclusion.bullets, data)),
      cta(fmt(conclusion.ctaTitle, data), fmt(conclusion.ctaText, data), data.target, data.path)
    ]),
    isTool
      ? buildToolScenarioSection(pack, data, localeBody, locale, target.intents)
      : buildModelScenarioSection(pack, data, localeBody, locale, target.intents),
    section('faq', pack.sections.faq, buildFaqBlocks(pack, isTool, data))
  ]

  if (localeBody && localeBody.links && localeBody.links.length) {
    sections.splice(9, 0, section('miral-workflow', localeBody.linksTitle || RELATED_LINK_TITLES[locale] || RELATED_LINK_TITLES.en, [
      p(localeBody.linksIntro || ''),
      links(localeBody.linksTitle || RELATED_LINK_TITLES[locale] || RELATED_LINK_TITLES.en, localeBody.links)
    ]))
  }

  if (localeBody && localeBody.sections && localeBody.sections.length) {
    sections = localeBody.sections
  }

  var layoutProfile = buildLayoutProfile(pack)
  var tldrSection = null
  var faqSection = null
  var i
  for (i = 0; i < sections.length; i++) {
    if (sections[i].id === 'tldr') tldrSection = sections[i]
    if (sections[i].id === 'faq') faqSection = sections[i]
  }
  if (tldrSection && tldrSection.title) {
    layoutProfile = Object.assign({}, layoutProfile, { tldrTitle: tldrSection.title })
  }
  if (faqSection && faqSection.title) {
    layoutProfile = Object.assign({}, layoutProfile, { faqTitle: faqSection.title })
  }

  return {
    sections: sections,
    creatingSteps: steps,
    pros: pros,
    cons: cons,
    searchTerms: (pack.searchTerms || BASE.searchTerms).concat([
      article.title,
      article.target && article.target.label
    ]).filter(Boolean),
    layoutProfile: layoutProfile
  }
}

module.exports = {
  buildArticleContent: buildArticleContent
}
